import { GetRecommendationPostsData } from 'models/swagger-spring/data-contracts';
import { useQuery } from 'react-query';
import axios from '@apis/spring-client';
import { useTranslation } from 'next-i18next';

export type RecommendationsPostsRequest = {
  language: 'KO' | 'EN';
  postsType: string;
};

const getRecommendationsPosts = async ({
  language,
  postsType,
}: RecommendationsPostsRequest): Promise<GetRecommendationPostsData> => {
  try {
    const response = await axios.get(`/api/posts/recommendation`, {
      params: {
        language,
        postsType,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const useGetRecommendationsPosts = ({ language, postsType }: RecommendationsPostsRequest) => {
  const { i18n, t } = useTranslation('component');

  return useQuery(['recommendationsPosts', language, postsType], () =>
    getRecommendationsPosts({ language, postsType }),
  );
};

export default useGetRecommendationsPosts;
